import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdleControlService {

  constructor() { }

  private activeRequests = 0;
  private readonly pauseSubject = new BehaviorSubject<boolean>(false);
  private readonly apiActivitySubject = new Subject<void>();

  pause$ = this.pauseSubject.asObservable();
  apiActivity$ = this.apiActivitySubject.asObservable();

  apiStarted(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.pauseSubject.next(true);
    }
  }

  apiFinished(): void {
    if (this.activeRequests === 0) return;
    this.activeRequests--;
    if (this.activeRequests === 0) {
      this.pauseSubject.next(false);
      this.apiActivitySubject.next();
    }
  }
}
